import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";

const btn = "px-3 py-1.5 rounded-full text-xs font-medium transition-colors";

const MessageCard = ({ m, onToggle }) => (
  <li data-testid={ADMIN.messageRow(m.id)} className={`bg-white border rounded-2xl p-4 text-sm ${m.status === "new" ? "border-[#E06D44]/40" : "border-[#F0EBE1] opacity-70"}`}>
    <div className="flex flex-wrap items-center gap-2">
      <span className="font-semibold">{m.name}</span>
      <span className="text-stone-500">{m.email}</span>
      {m.order_id && <span className="px-2 py-0.5 rounded-full bg-[#F0EBE1] text-xs">{m.order_id}</span>}
      {m.status === "new" && <span className="px-2 py-0.5 rounded-full bg-[#E06D44] text-white text-xs">New</span>}
      {m.emailed === false && <span className="px-2 py-0.5 rounded-full bg-amber-100 text-amber-800 text-xs">Email didn't send, reply from here</span>}
      <span className="ml-auto text-xs text-stone-400">{new Date(m.created_at).toLocaleString()}</span>
    </div>
    <p className="mt-2 whitespace-pre-wrap text-stone-700">{m.message}</p>
    <div className="mt-3 flex gap-2">
      <a data-testid={ADMIN.messageReply(m.id)} href={`mailto:${m.email}?subject=${encodeURIComponent("Re: your message to PetTok Shop")}`} className={`${btn} bg-[#1C1917] text-white hover:bg-[#E06D44]`}>Reply by email</a>
      <button data-testid={ADMIN.messageToggle(m.id)} onClick={() => onToggle(m)} className={`${btn} bg-[#F0EBE1] hover:bg-[#E7E0D3]`}>{m.status === "new" ? "Mark done" : "Mark as new"}</button>
    </div>
  </li>
);

export const AdminMessages = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/messages").then(({ data }) => setItems(data)).catch(() => setItems([])); }, []);
  const onToggle = async (m) => {
    const status = m.status === "new" ? "done" : "new";
    try {
      await api.put(`/admin/messages/${m.id}`, { status });
      setItems((l) => l.map((x) => (x.id === m.id ? { ...x, status } : x)));
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (!items) return <div className="mt-6 h-32 rounded-2xl bg-[#F0EBE1] animate-pulse" />;
  return (
    <section className="mt-6">
      <p className="text-xs text-stone-500">Messages from the contact form on the Shipping, returns &amp; contact page. Each one is also emailed to your inbox.</p>
      {items.length
        ? <ul data-testid={ADMIN.messagesList} className="mt-4 space-y-3">{items.map((m) => <MessageCard key={m.id} m={m} onToggle={onToggle} />)}</ul>
        : <p data-testid={ADMIN.messagesEmpty} className="mt-4 text-sm text-stone-500">No messages yet.</p>}
    </section>
  );
};
